<template>
  <div>
    <v-row v-if="!isOrganizationManager" class="pt-5">
      <v-col cols="12" sm="6" md="3">
        <v-autocomplete
          :disabled="loading"
          hide-details
          v-model="organization"
          :items="organizations"
          item-value="_id"
          outlined
          dense
          background-color="white"
          :label="$t('user.registration.organization')"
          class="rounded-lg"
          clearable
          :filter="customLocalisedAutoCompleteFilter"
        >
          <template slot="selection" slot-scope="data">
            {{ getLocalisedValue(data.item.name) }}
          </template>
          <template v-slot:item="{ item }">
            <div class="d-flex justify-start">
              {{ getLocalisedValue(item.name) }}
            </div>
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="text-start">
        <span class="textLight--text text font-weight-medium text-h5">
          {{ $t("reports.matrix.matrixPriority") }}
        </span>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" sm="6" md="3">
        <v-card flat class="px-4 py-3" height="100%">
          <v-row align="center">
            <v-col cols="5">
              <span class="textLight--text">
                {{ $t("reports.matrix.expiryDate") }}
              </span></v-col
            >

            <v-col cols="2">
              <v-switch
                flat
                dense
                hide-details
                inset
                color="primary"
                class="ma-0"
                v-model="matrixPrioritySwitch"
              >
              </v-switch
            ></v-col>

            <v-col cols="auto" class="text-start">
              <span class="textLight--text">
                {{ $t("user.registration.startDate") }}
              </span>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="pt-7">
      <v-col class="text-start" cols="12" sm="6" md="8">
        <span class="textLight--text font-weight-medium text-h5">
          {{ $t("reports.matrix.trainingMatrix") }}
        </span>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-row>
          <v-col cols="12" sm="8">
            <v-text-field
              v-model="search"
              hide-details
              prepend-inner-icon="mdi-magnify"
              color="textLight"
              :placeholder="$t('course.search')"
              outlined
              dense
              background-color="white"
              clearable
              class="shrink rounded-lg"
            />
          </v-col>
          <v-col cols="12" sm="4">
            <v-menu>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :disabled="loading"
                  height="45"
                  block
                  outlined
                  style="text-transform: unset"
                  class="rounded-lg textLight--text font-weight-thin button"
                  v-bind="attrs"
                  v-on="on"
                  :loading="exportBtnLoading"
                >
                  <v-icon>mdi-export</v-icon>
                  {{ $t("reports.export") }}
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(item, i) in exportItems"
                  :key="i"
                  class="hand-cursor"
                >
                  <v-list-item-title @click="exportTo(item.value)">
                    <div class="d-flex align-center justify-space-between">
                      {{ item.text }}
                      <v-icon size="25" :color="item.iconColor" class="ms-2">{{
                        item.icon
                      }}</v-icon>
                    </div>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <TrainingMatrixReportsList
          :trainingMatrixReports="trainingMatrixReportsData"
          :loading="loading"
          :courses="validCourses"
          :startDatePriority="matrixPrioritySwitch"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        v-if="trainingMatrixReportsData && trainingMatrixReportsData.length"
      >
        <Pagination :length="totalPages" @onPageSelect="onPagination" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import TrainingMatrixReportsList from "./TrainingMatrixReportsList.vue";
import Pagination from "../../core-module/components/Pagination.vue";

import { excelExport } from "../methods/excelExport";

export default {
  components: {
    TrainingMatrixReportsList,
    Pagination,
  },
  data() {
    return {
      loading: true,
      trainingMatrixReportsData: [],
      search: null,
      organization: null,
      organizations: [],
      coursesData: [],
      validCourses: [],
      exportItems: [
        {
          value: "xl",
          text: this.$t("reports.exportTo"),
          icon: "mdi-microsoft-excel",
          iconColor: "success",
        },
        // {
        //   value: "pdf",
        //   text: this.$t("reports.exportTo"),
        //   icon: "mdi-file-pdf-box",
        //   iconColor: "error",
        // },
      ],
      exportBtnLoading: false,
      matrixPrioritySwitch: false,
      totalCount: 0,
      variables: {
        limit: 10,
        skip: 0,
      },
      filterInputs: {},
      reRender: 0,
    };
  },
  computed: {
    isOrganizationManager() {
      return (
        this.$store.state.authenticatedUser?.isOrganizationManager ?? false
      );
    },
  },
  apollo: {
    getOrganizations() {
      return {
        query: require("../../organization-module/api/query/getOrganizations.gql"),
        variables: { limit: 0, skip: 0, filterInput: null },
        result({ data, loading }) {
          if (
            data &&
            data.getOrganizations &&
            data.getOrganizations.organizations
          ) {
            this.organizations = data.getOrganizations.organizations;
          }
        },
      };
    },
    getTrainings() {
      return {
        query: require("../../course-module/api/query/getTrainings.gql"),
        variables: {
          limit: 0,
          skip: 0,
          filterInput: {
            approvalStatus: "APPROVED",
          },
        },
        result({ data, loading }) {
          if (data && data.getTrainings && data.getTrainings.trainings) {
            this.coursesData = data.getTrainings.trainings;
          }
          this.reRender++;
        },
      };
    },
    getTrainingMatrixReports() {
      return {
        query: require("../api/query/getTrainingMatrixReports.gql"),
        variables: this.variablesDefaultValue(),
        watchLoading(isLoading) {
          this.loading = isLoading;
        },
        result({ data, loading }) {
          if (
            data &&
            data.getTrainingMatrixReports &&
            data.getTrainingMatrixReports.trainingMatrixReports
          ) {
            this.trainingMatrixReportsData =
              data.getTrainingMatrixReports.trainingMatrixReports;
            this.totalCount = data.getTrainingMatrixReports.totalCount;
            let pagesVal = this.totalCount / this.variablesDefaultValue().limit;
            this.totalPages = this.checkNumberIsFloat(pagesVal)
              ? Math.ceil(pagesVal)
              : pagesVal;
          }
          this.loading = loading;
          this.reRender++;
        },
      };
    },
  },
  watch: {
    reRender: {
      immediate: false,
      async handler() {
        this.validCourses = [];
        if (this.trainingMatrixReportsData?.length) {
          let registrations = await this.getAllRegistrations(
            this.trainingMatrixReportsData
          );

          this.coursesData.map(course => {
            let findVal = registrations.find(
              reg => reg.training._id === course._id
            );
            if (findVal) this.validCourses.push(course);
          });
        }
      },
      deep: true,
    },
    search: {
      immediate: false,
      handler() {
        clearTimeout(this.debounceSearch);
        this.debounceSearch = setTimeout(() => {
          this.apiSearch(this.search);
        }, 500);
      },
    },
    organization() {
      if (!this.organization) {
        delete this.filterInputs?.organization;
      } else {
        this.filterInputs.organization = this.organization;
      }
      this.variables = this.variablesDefaultValue();
      this.refetch();
    },
  },
  methods: {
    variablesDefaultValue() {
      return {
        limit: 10,
        skip: 0,
      };
    },
    checkNumberIsFloat(value) {
      return Number(value) === value && value % 1 !== 0;
    },
    async apiSearch(val) {
      const searchText = val?.trim() ?? "";

      if (searchText.length > 0) {
        this.filterInputs.search = searchText;
        this.variables = this.variablesDefaultValue();
        await this.refetch();
      } else if (searchText.length === 0 && this.filterInputs?.search != null) {
        delete this.filterInputs?.search;
        this.variables = this.variablesDefaultValue();
        await this.refetch();
      }
    },

    exportTo(val) {
      if (val === "xl") this.exportToXL();
    },
    async exportToXL() {
      this.exportBtnLoading = true;
      let exportArr = await this.$apollo
        .query({
          query: require("../api/query/getTrainingMatrixReports.gql"),
          variables: {
            limit: 0,//1000,//export limit
            skip: 0,
            filterInput: this.filterInputs,
          },
        })
        .then(async result => {
          this.exportBtnLoading = false;
          let data =
            result?.data?.getTrainingMatrixReports?.trainingMatrixReports;
          let registrations = [];
          if (data?.length) {
            registrations = await this.getAllRegistrations(data);

            let trainingMatrixExportData = data.map(
              (trainingMatrixObj, index) => {
                let obj = {};
                obj[this.$t("reports.matrix.sNo")] = index + 1;
                obj[this.$t("user.civilIdOrPassport")] = trainingMatrixObj
                  ?.employee?.user?.civilIdOrPassport
                  ? trainingMatrixObj.employee.user.civilIdOrPassport
                  : " - ";
                obj[this.$t("reports.employee")] = trainingMatrixObj?.employee
                  ?.user?.firstName
                  ? `${trainingMatrixObj.employee.user.firstName || ""} ${
                      trainingMatrixObj.employee.user.lastName || ""
                    }`
                  : " - ";
                obj[this.$t("user.department")] = trainingMatrixObj?.employee
                  ?.department
                  ? trainingMatrixObj.employee.department
                  : " - ";
                obj[this.$t("user.designation")] = trainingMatrixObj?.employee
                  ?.designation
                  ? trainingMatrixObj.employee.designation
                  : " - ";
                if (
                  this.coursesData?.length &&
                  trainingMatrixObj?.trainingRegistrations
                ) {
                  this.coursesData.map(course => {
                    let findVal = registrations.find(
                      reg => reg.training._id === course._id
                    );
                    if (findVal) {
                      obj[
                        this.getLocalisedValue(course.title)
                        // `${this.$t("course.course")}: ${this.getLocalisedValue(
                        //   course.title
                        // )}`
                      ] =
                        trainingMatrixObj &&
                        trainingMatrixObj.trainingRegistrations
                          ? this.findTrainingRegistrations(
                              course._id,
                              trainingMatrixObj
                            )
                          : " - ";
                    }
                  });
                }

                return obj;
              }
            );
            return trainingMatrixExportData;
          } else return [];
        });
      let name = "training-matrix-reports";
      let fileName = name.concat("-", this.$moment().unix());
      excelExport(exportArr, fileName);
    },
    async getAllRegistrations(arr) {
      let registrationsData = [];
      await arr.map(val => {
        if (val?.trainingRegistrations?.length) {
          registrationsData.push(...val.trainingRegistrations);
        }
      });
      return registrationsData;
    },
    findTrainingRegistrations(courseId, trainingMatrixData) {
      let trainingRegistrations =
        trainingMatrixData?.trainingRegistrations ?? [];
      if (courseId && trainingRegistrations?.length) {
        let findRegistrations = trainingRegistrations.filter(
          obj => obj?.training?._id === courseId
        );
        let result = "";
        if (findRegistrations?.length) {
          let sortedArr = findRegistrations.sort(
            (a, b) =>
              parseInt(
                this.matrixPrioritySwitch
                  ? b?.startDate
                  : b?.trainingCertificate?.expiresAt
              ) -
              parseInt(
                this.matrixPrioritySwitch
                  ? a?.startDate
                  : a?.trainingCertificate?.expiresAt
              )
          );
          let datesArr = sortedArr
            .map(val => {
              if (this.matrixPrioritySwitch)
                return val?.startDate
                  ? this.$moment(parseInt(val.startDate)).format("DD MMM YYYY")
                  : null;
              else
                return val?.trainingCertificate?.expiresAt
                  ? this.$moment(parseInt(val.trainingCertificate.expiresAt)).format(
                      "DD MMM YYYY"
                    )
                  : null;
            })
            .filter(d => d);

          result = datesArr?.length ? datesArr[0] : "";
          // findRegistrations.map((val, index) => {
          //   result = result.concat(
          //     index > 0 ? ", " : "",
          //     this.$moment(
          //       parseInt(
          //         this.matrixPrioritySwitch ? val?.startDate : val?.endDate
          //       )
          //     ).format("DD MMM YYYY")
          //   );
          // });
        }
        if (result && result !== "") return result;
        else return " - ";
      } else return " - ";
    },

    onPagination(val) {
      if (val > 0) {
        this.variables.skip = this.variables.limit * (val - 1);
        this.refetch();
      }
    },
    async refetch() {
      this.loading = true;
      await this.$apollo.queries.getTrainingMatrixReports.refetch({
        limit: this.variables.limit,
        skip: this.variables.skip,
        filterInput: this.filterInputs,
      });
    },
  },
};
</script>
